<!-- @format -->

<sis-contextual-notification variant="light">
  @if (versionSwitchAllowed) {
    <span>{{ versionCompatibleTranslationKey | translate }}</span
    >&nbsp;
    @if (allowEdit) {
      <sis-button [link]="true" data-cy="switch-to-this-version-button" (clicked)="saveVersionChange.emit()">{{
        switchVersionTranslationKey | translate
      }}</sis-button>
    }
  } @else {
    <span>{{ versionNotCompatibleTranslationKey | translate }}</span>
  }
</sis-contextual-notification>
